//*Libraries imports
import { z } from "zod";

//*Schemas imports
import { PaymentStatusSchema, PaymentDetailsSchema } from "./payment";
import { ClientSchema } from "./client";
import { productSchema } from "./product";
import { UserSchema } from "./user";
import { MethodPaymentEnum } from "./methodpayment";
import { FinancialConfigSchema } from "./financial";

//* Types imports
export const SaleTypeSchema = z.enum(["Produto Completo"]);
export type SaleType = z.infer<typeof SaleTypeSchema>;
export const SaleType = {
  COMPLETE_PRODUCT: "Produto Completo",
} as const;

export const SaleVerificationTokenSchema = z.object({
  token: z.string(),
  expiresAt: z.union([z.string(), z.date()]),
});
export type SaleVerificationToken = z.infer<typeof SaleVerificationTokenSchema>;

export const ValidateSaleTokenInputSchema = z.object({
  token: z.string().min(1, "Token é obrigatório"),
});
export type ValidateSaleTokenInput = z.infer<
  typeof ValidateSaleTokenInputSchema
>;

export const ISaleSchema = z.object({
  id: z.string().optional(),
  _id: z.string().optional(),
  orderNumber: z.string().optional(),
  clientId: z.union([z.string(), ClientSchema]),
  productId: z.union([z.string(), productSchema]),
  responsibleId: z.union([z.string(), UserSchema]).optional(),
  saleType: SaleTypeSchema,
  financialConfig: FinancialConfigSchema.optional(),
  managerDiscount: z.number().optional(),
  paymentStatus: PaymentStatusSchema,
  paymentDetails: PaymentDetailsSchema.optional(),
  verificationToken: SaleVerificationTokenSchema.optional(),
  saleDate: z.union([z.string(), z.date()]).nullable(),
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});
export type ISale = z.infer<typeof ISaleSchema>;

export const ISaleInputDTOSchema = z.object({
  clientId: z.string(),
  productId: z.string(),
  financialConfig: FinancialConfigSchema.optional(),
  managerDiscount: z.number().optional(),
  responsibleId: z.string().optional(),
  saleType: SaleTypeSchema.optional(),
  paymentStatus: PaymentStatusSchema.optional(),
  paymentDetails: PaymentDetailsSchema.partial().optional(),
  saleDate: z.union([z.string(), z.date()]).optional(),
});
export type ISaleInputDTO = z.infer<typeof ISaleInputDTOSchema>;

export const ISaleOutputDTOSchema = ISaleSchema.extend({
  id: z.string(),
  orderNumber: z.string(),
  _id: z.string().optional(),
  saleType: SaleTypeSchema,
  paymentStatus: PaymentStatusSchema,
  paymentDetails: PaymentDetailsSchema,
  saleDate: z.union([z.string(), z.date()]).optional(),
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});
export type ISaleOutputDTO = z.infer<typeof ISaleOutputDTOSchema>;

export const ISaleFiltersSchema = z.object({
  paymentStatus: z
    .union([PaymentStatusSchema, z.array(PaymentStatusSchema)])
    .optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});
export type ISaleFilters = z.infer<typeof ISaleFiltersSchema>;

export const saleSchemaForm = z.object({
  clientId: z.string().min(1, "Selecione um cliente"),
  productId: z.string().min(1, "Selecione um produto"),
  responsibleId: z.string().optional(),
  financialConfig: FinancialConfigSchema.optional(),
  managerDiscount: z.number().optional(),
  saleType: z.nativeEnum(SaleType),
  paymentStatus: z.string(),
  saleDate: z.any().nullable(),
});

export type SaleFormData = z.infer<typeof saleSchemaForm>;
